import React, { useEffect, useState } from 'react'
import { useHistory, Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useFilterButton } from '../../../provider/FilterButtonProvider'

import Button from '../../../components/ui/button'
import TagsBlock from './tagsBlock'

import { TagList } from '../../../store/tags/tagsTyping'
import { RootState } from '../../../store/rootReducer'

import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths, { pureUrls } from '../../../paths'
import { scrollToTop } from '../../../store/common/commonSlice'
import { clearTagAndSlug, fetchSearchList, fetchTagsList, setCurrentSlug } from '../../../store/tags/tagsSlice'
import './tagsFilters.sass'
import ButtonLink from '../../../components/ui/buttonLink'

const TagsFilters: React.FunctionComponent = () => {
    const [t] = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    const tags = useSelector<RootState, TagList>((state) => state.tags.tags)
    const currentTag = useSelector<RootState, string>((state) => state.tags.currentTag)
    const currentSlug = useSelector<RootState, string>((state) => state.tags.currentSlug)

    const [isPopupOpen, setIsPopupOpen] = useState(false)
    const [inputValue, setInputValue] = useState('')

    const handleApplyFilters = () => {
        dispatch(setCurrentSlug(inputValue))
        inputValue
            ? history.push({
                  pathname: location.pathname,
                  search: `?query=${inputValue}`
              })
            : history.push(location.pathname)
        setIsPopupOpen(false)
    }

    useEffect(() => {
        setInputValue(currentTag)
    }, [currentTag])

    useFilterButton(isPopupOpen, setIsPopupOpen, true)

    return (
        <>
            <div className={isPopupOpen ? 'searchBlock absolute' : 'searchBlock'}>
                <input
                    data-testid="search_input"
                    type="text"
                    placeholder={t('What are you looking for')}
                    onClick={() => {
                        setIsPopupOpen(true)
                        dispatch(scrollToTop())
                    }}
                    onKeyDownCapture={(e) => {
                        if (e.key == 'Enter') handleApplyFilters()
                    }}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                />
                <div className="buttonsWrapper">
                    <ButtonLink
                        linkUrl={createLocalizedPath(
                            (location.pathname.includes('/contributions/') ? '/tags/contributions/' : '/tags/') +
                                currentSlug
                        )}
                        label={t('Tout')}
                        secondary={location.pathname.includes('/photo/') || location.pathname.includes('/video/')}
                    />
                    <ButtonLink
                        linkUrl={createLocalizedPath(
                            (location.pathname.includes('/contributions/')
                                ? '/tags/contributions/photo/'
                                : '/tags/photo/') + currentSlug
                        )}
                        label={t('Photo')}
                        secondary={!location.pathname.includes('/photo/')}
                    />
                    <ButtonLink
                        linkUrl={createLocalizedPath(
                            (location.pathname.includes('/contributions/')
                                ? '/tags/contributions/video/'
                                : '/tags/video/') + currentSlug
                        )}
                        label={t('Video')}
                        secondary={!location.pathname.includes('/video/')}
                    />
                </div>
            </div>
            {isPopupOpen && (
                <div
                    data-testid="closePopup"
                    className="searchPopup"
                    onClick={() => {
                        setIsPopupOpen(false)
                    }}
                >
                    <div className="closeLabels" onClick={handleApplyFilters}></div>
                    <div
                        className="searchBlockWrapper"
                        onClick={(e) => {
                            e.stopPropagation()
                        }}
                    >
                        <TagsBlock tags={tags.list} chosenTag={inputValue} setIsPopupOpen={setIsPopupOpen} />
                        <div className="buttonsBottom">
                            <div>
                                <Link
                                    onClick={() => {
                                        dispatch(fetchTagsList({ order: '', p: 1 }))
                                    }}
                                    to={{
                                        pathname: createLocalizedPath(paths.tags.path),
                                        search: '?p=1'
                                    }}
                                >
                                    {t('View all tags')}
                                </Link>
                                <Link
                                    onClick={() => {
                                        dispatch(fetchSearchList({ p: 1 }))
                                    }}
                                    to={{
                                        pathname: createLocalizedPath(paths.recherche.path),
                                        search: '?p=1'
                                    }}
                                >
                                    {t('View all searches')}
                                </Link>
                            </div>
                            <div>
                                <p
                                    onClick={() => {
                                        dispatch(clearTagAndSlug())
                                        history.push({
                                            pathname: createLocalizedPath(
                                                location.pathname.includes('/contributions/')
                                                    ? '/tags/contributions/'
                                                    : '/tags/'
                                            )
                                        })
                                        setIsPopupOpen(false)
                                    }}
                                >
                                    {t('Clear filters')}
                                </p>
                                <Button
                                    label={t('Apply filters')}
                                    onClick={() => {
                                        handleApplyFilters()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default TagsFilters
